import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ConfigService } from '../config.service';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class PhotoboothService {
  constructor(
    private http: HttpClient,
    private config: ConfigService,
  ) {}

  // authenticated MC user; token is HMAC payload from submit, not a password
  approveProfilePhoto(token: string): Observable<void> {
    return this.http.post<void>(`${this.config.dataApiUrl}/photobooth/profile/approve`, { token });
  }
}

